import { ROUTES } from '@/const/route'
import { useAuthStore } from '@/stores/authStore'

/**
 * Navigation guard that ensures user is authenticated
 * Redirects to login page if not signed in
 * @param {RouteLocationNormalized} to - Target route
 * @param {RouteLocationNormalized} from - Current route
 * @returns {NavigationGuardReturn} Navigation result or undefined to proceed
 */
export async function requiresAuth(to, from) {
  const authStore = useAuthStore()
  const signedIn = await authStore.isUserSignedIn()

  if (!signedIn) {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    if (requiresAuth) {
      const loginPath = window.location.pathname
      return { name: ROUTES.LOGIN, query: { from: loginPath } }
    }
  }

  return undefined
}
